module.exports = __webpack_public_path__ + "static/media/white-pricing-card.cd2f355e.jpg";